<template>
  <div class="rms-order-food">
    <a-layout style="height:calc(100vh - 125px)">
      <a-layout-sider style="background:#fff;" :width="550">
        <div class="rms-order-wraper">
          <div class="rms-order-info">
            <div class="rms-order-header">
              <div class="date-range">
                <a-date-picker
                  v-model="startValue"
                  :allowClear="false"
                  showTime
                  :disabled-date="disabledStartDate"
                  @openChange="handleStartOpenChange"
                  format="YYYY-MM-DD HH:mm"
                />
                至
                <a-date-picker
                  v-model="endValue"
                  :disabled-date="disabledEndDate"
                  :open="endOpen"
                  format="YYYY-MM-DD HH:mm"
                  showTime
                  :allowClear="false"
                  @openChange="handleEndOpenChange"
                />
              </div>
            </div>
            <div class="rms-order-table">
              <data-grid
                ref="orderTable"
                size="middle"
                :columns="orderColumns"
                v-model="orderFoodList"
                :pagination="false"
                :props="orderTableProps"
                :locale="{ emptyText: '请选择右侧菜品进行操作' }"
                rowKey="_id"
              >
                <template slot="name" slot-scope="text, record">
                  <div class="food-title multi-line" style="text-align:left;">
                    <span
                      ><i
                        class="iconfont icon-guqing"
                        v-if="record.IsSoldOut"
                        style="color:#f00"
                      ></i>
                      {{ text }}</span
                    >
                  </div>
                </template>
              </data-grid>
            </div>
          </div>
          <div class="rms-order-actions">
            <div class="rms-order-actions_box">
              <a @click="soldOut">估清</a>
              <!-- <a>+1</a>
              <a>-1</a>
              <a>数量</a>
              <a>删除</a>
              <a>启用</a>
              <a>禁用</a> -->
              <a @click="getSoldOut">已估清</a>
              <a @click="cancelSoldOut">取消估清</a>
              <a @click="reset">清空</a>
            </div>
          </div>
        </div>
      </a-layout-sider>
      <a-layout-content style="padding: 10px 0 0 10px!important;">
        <FoodSelect
          ref="FoodSelect"
          :isChecked="true"
          @getFoodList="getFoodList"
          @foodClick="addFood"
        />
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
import moment from "moment";
import "./rms.less";
import "./orderFood.less";
import FoodSelect from "./foodSelect/foodSelect";
export default {
  components: { DataGrid, FoodSelect },
  data() {
    return {
      orderColumns: [
        {
          title: "菜名",
          width: "130px",
          dataIndex: "AccountItemName",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "单位",
          dataIndex: "UnitName",
          width: "60px"
        },
        {
          title: "单价",
          dataIndex: "UnitPrice",
          width: "60px"
        },
        {
          title: "描述",
          dataIndex: "ForbiddenTime"
        },
        {
          title: "操作",
          dataIndex: "_id",
          width: "60px",
          fixed: "right",
          customRender: (text, record, index) => {
            const del = {
              click: () => {
                this.orderFoodList.splice(index, 1);
              }
            };
            return (
              <a-icon
                style="color:#f00;font-size:18px"
                {...{ on: del }}
                type="close-circle"
              />
            );
          }
        }
      ],
      orderTableProps: {
        scroll: { x: 560, y: "calc(100vh - 215px)" },
        locale: { emptyText: "请选择右侧菜品进行操作" }
      },
      foodClassList: [],
      foodList: [],
      foodSelectWraperWidth: "",
      orderFoodList: [],
      foodClassKey: 0,
      startValue: moment(),
      endValue: moment().add(1, "d"),
      endOpen: false
    };
  },
  computed: {
    gridColumns() {
      const num = Math.round(this.foodSelectWraperWidth / 160);
      let columns = "";
      for (let i = 0; i < num; i++) {
        columns = `${columns} 1fr`;
      }
      return columns;
    },
    selectedKeys() {
      return this.orderFoodList.map(v => v.AccountItemId);
    }
  },
  created() {
    this.routeQuery = this.$route.query;
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.updateFoodSelectWraperWidth();
      })();
    };
    setTimeout(() => {
      this.updateFoodSelectWraperWidth();
    }, 10);
  },

  methods: {
    reset() {
      this.orderFoodList = [];
      this.$refs.FoodSelect.setSelected([]);
    },
    getFoodList(list) {
      this.foodList = list;
    },
    getSoldOut() {
      this.$refs.FoodSelect.setSelected([]);
      const list = this.foodList.filter(item => item.IsSoldOut);
      this.orderFoodList = list.map(item => {
        return {
          _id: new Date().getTime() + parseInt(Math.random() * 1000),
          AccountItemId: item.DishId,
          AccountItemName: item.DishName,
          UnitPrice: item.UnitPrice,
          ForbiddenTime: item.ForbiddenTime,
          Quantity: 1,
          IsSoldOut: item.IsSoldOut,
          UnitName: item.UnitName
        };
      });
    },
    cancelSoldOut() {
      this.onSubmit(2);
    },
    soldOut() {
      this.onSubmit(1);
    },
    onSubmit(type) {
      const tip =
        type == 1 ? "请先选择需要估清的菜品" : "请先选择取消估清的菜品";
      const msg = type == 1 ? "是否确认进行估清?" : "是否确认取消估清?";
      const api = type == 1 ? "SetFoodSoldOut" : "CancelFoodSoldOut";
      if (!this.orderFoodList.length) {
        this.$message.warning(tip);
        return false;
      }
      const ids = this.orderFoodList.map(v => v.AccountItemId);
      const _this = this;
      this.$confirm({
        title: msg,
        onOk() {
          const params = {
            BeginTime: moment(_this.startValue).format("YYYY-MM-DD HH:mm"),
            EndTime: moment(_this.endValue).format("YYYY-MM-DD HH:mm"),
            FoodIds: ids
          };
          _this.$post(api, params).then(() => {
            _this.$message.success("操作成功");
            _this.orderFoodList = [];
            _this.$refs.FoodSelect.init();
          });
        }
      });
    },
    disabledStartDate(current) {
      return current && current < moment().startOf("day");
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    updateFoodSelectWraperWidth() {
      const foodSelectWraper = document.getElementById("foodSelectWraper");
      if (foodSelectWraper) {
        this.foodSelectWraperWidth = foodSelectWraper.offsetWidth;
      }
    },
    setOrderTableToBottom() {
      const orderTable = this.$refs.orderTable;
      const el = orderTable.$el;
      const tableBody = el.getElementsByClassName("ant-table-body");
      if (tableBody && tableBody.length) {
        setTimeout(() => {
          tableBody[0].scrollTop = tableBody[0].scrollHeight;
        }, 10);
      }
    },
    addFood(item) {
      // if (item.IsSoldOut || item.Status == 0) {
      //   return;
      // }
      const isExzist = this.orderFoodList.find(
        el => el.AccountItemId == item.DishId
      );
      if (isExzist) {
        return false;
      }
      const row = {
        _id: new Date().getTime() + parseInt(Math.random() * 1000),
        AccountItemId: item.DishId,
        AccountItemName: item.DishName,
        UnitPrice: item.UnitPrice,
        ForbiddenTime: item.ForbiddenTime,
        Quantity: 1,
        IsSoldOut: item.IsSoldOut,
        UnitName: item.UnitName
      };
      this.orderFoodList.push(row);
      this.$refs.orderTable.setGridData(row);
      this.setOrderTableToBottom();

      // }
    }
  }
};
</script>
<style lang="less" scoped></style>
